import { render, staticRenderFns } from "./DoctorClinicCode.vue?vue&type=template&id=23c3af64&"
import script from "./DoctorClinicCode.vue?vue&type=script&lang=js&"
export * from "./DoctorClinicCode.vue?vue&type=script&lang=js&"
import style0 from "./DoctorClinicCode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports